import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { BellRing, Loader2, KeyRound } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DropAlerts = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);
  const [joined, setJoined] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())) {
      setError("Enter a valid email address.");
      return;
    }
    setError("");
    setSending(true);
    try {
      const data = new FormData();
      data.append("email", email.trim());
      data.append("name", name.trim());
      const res = await axios.post(`${API}/drop-alerts`, data);
      setJoined(true);
      toast.success(
        res.data.already_subscribed
          ? "You're already on the drop list — treasure finds you soon."
          : "You're on the list — watch your inbox for a confirmation."
      );
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Couldn't join right now — try again in a moment.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="card-frame foil-sheen relative overflow-hidden p-8 text-center sm:p-12" data-testid="drop-alerts-widget">
      <div className="absolute left-1/2 top-0 -translate-x-1/2" aria-hidden="true">
        <div className="keyhole opacity-60" />
      </div>
      {joined ? (
        <div data-testid="drop-alerts-success">
          <KeyRound className="mx-auto mt-6 text-gold" size={40} />
          <h3 className="mt-5 font-serif text-2xl font-bold text-cream">The vault key is yours</h3>
          <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-cream/70">
            You're on the drop list. A confirmation is on its way to your inbox — and the next treasure drop will
            find you before anyone else.
          </p>
        </div>
      ) : (
        <>
          <BellRing className="mx-auto mt-6 text-gold" size={36} />
          <h3 className="mt-5 font-serif text-2xl font-bold tracking-tight text-cream sm:text-3xl">
            Vault drop alerts
          </h3>
          <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-cream/70">
            Curated singles, sealed treasures, and collection highlights move fast. Join the list and every new
            find has your name on it first.
          </p>
          <form onSubmit={onSubmit} className="mx-auto mt-8 flex max-w-lg flex-col gap-3 sm:flex-row" data-testid="drop-alerts-form" noValidate>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Name (optional)"
              aria-label="Name (optional)"
              className="field sm:w-44"
              data-testid="drop-alerts-name-input"
            />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              aria-label="Email address"
              className="field flex-1"
              data-testid="drop-alerts-email-input"
            />
            <button type="submit" className="btn-gold shrink-0 !px-6" disabled={sending} data-testid="drop-alerts-submit-button">
              {sending ? <Loader2 className="animate-spin" size={16} /> : null}
              {sending ? "Joining…" : "Alert Me"}
            </button>
          </form>
          {error && <p className="mt-3 text-xs text-red-400" data-testid="drop-alerts-error">{error}</p>}
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-cream/40">
            No spam · Only real treasure alerts · Unsubscribe anytime
          </p>
        </>
      )}
    </div>
  );
};

export default DropAlerts;
